module.exports = __webpack_public_path__ + "static/kitchen-silly.e50c4f7b.jpg";